import React, { useEffect, useState } from "react"
import moment from "moment"
import Modal from "../Modal"
import AppLogo from "../Logos/AppLogo"
import AppleShareIcon from "./AppleShareIcon"
import { WhiteAppButton } from "../Buttons/Buttons"

// This code is referenced from
// https://medium.com/swlh/a-simple-react-hook-to-prompt-ios-users-to-install-your-wonderful-pwa-4cc06e7f31fa

interface OutICheckForIOS {
  isIOS?: boolean
  isSafari?: boolean
  prompt?: boolean
}

const checkForIOS = (): OutICheckForIOS => {
  if (!window) return {}
  const isInStandaloneMode =
    "standalone" in window.navigator && window.navigator["standalone"]
  if (isInStandaloneMode) return {}
  const today = moment().toDate()
  const lastPrompt = moment(localStorage.getItem("installPrompt"))
  const days = moment(today).diff(lastPrompt, "days")
  const ua = window.navigator.userAgent
  const webkit = !!ua.match(/WebKit/i)
  const isIPad = !!ua.match(/iPad/i)
  const isNewIPadOS =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints === 5
  const isIPhone = !!ua.match(/iPhone/i)
  const isIOS = isIPad || isIPhone || isNewIPadOS
  const isSafari = isIOS && webkit && !ua.match(/CriOS/i)
  const prompt = (isNaN(days) || days > 7) && isIOS && isSafari
  if (prompt && "localStorage" in window) {
    localStorage.setItem("installPrompt", today.toString())
  }
  return { isIOS, isSafari, prompt }
}

const ComponentView: React.FC<{
  isIOS: OutICheckForIOS
}> = ({ isIOS }) => {
  const [showModal, setShowModal] = useState(false)
  useEffect(() => {
    setShowModal(isIOS.prompt || false)
  }, [isIOS])
  return (
    <Modal
      show={showModal}
      onClose={() => {
        setShowModal(false)
      }}
    >
      <div
        className="bg-gray-200 block bg-white text-site-blue p-4 rounded shadow text-center"
        style={{ minWidth: "300px", maxWidth: "310px" }}
      >
        <div className="flex item-center justify-center my-2">
          <AppLogo width={58} dontGoToHome={true} />
        </div>
        <h1 className="text-site-blue text-xl sm:text-lg py-2">
          Install Personal GDM
        </h1>
        <p className="text-gray-800 text-sm sm:text-xs">
          Install this application on your home screen for a better experience.
        </p>
        <p className="text-site-blue text-sm sm:text-xs flex items-center py-3 justify-center">
          <span>Tap</span>{" "}
          <span>
            <AppleShareIcon width={25} />
          </span>{" "}
          <span>then "Add to Home Screen"</span>
        </p>
        <div className="flex items-center justify-center">
          <WhiteAppButton
            title={"CLOSE"}
            onClick={() => setShowModal(false)}
            className="bg-gray-200"
          />
        </div>
      </div>
    </Modal>
  )
}

const OnIOSPromptToInstallPWA = () => {
  const [isIOS, setIsIOS] = useState<OutICheckForIOS>({})

  useEffect(() => {
    setIsIOS(checkForIOS())
  }, [])

  return <ComponentView isIOS={isIOS} />
}

export default OnIOSPromptToInstallPWA
